module.exports = __webpack_public_path__ + "img/bituminous_felt.5739f5bc.jpg";